export const formatDobInput = (value: string) => {
  let digits = value.replace(/\D/g, '').slice(0, 8);
  if (!digits) return '';
  let day = digits.slice(0, 2);
  let month = digits.slice(2, 4);
  const year = digits.slice(4, 8);

  if (day.length === 1 && Number(day) > 3) {
    day = `0${day}`;
  }
  if (day.length === 2) {
    const dayNum = Math.min(Math.max(Number(day), 1), 31);
    day = String(dayNum).padStart(2, '0');
  }
  if (month.length === 1 && Number(month) > 1) {
    month = `0${month}`;
  }
  if (month.length === 2) {
    const monthNum = Math.min(Math.max(Number(month), 1), 12);
    month = String(monthNum).padStart(2, '0');
  }

  if (digits.length <= 2) return day;
  if (digits.length <= 4) return `${day}-${month}`;
  return `${day}-${month}-${year}`;
};

export const formatDobFromIso = (value: string) => {
  if (!value) return '';
  const trimmed = value.trim();
  if (!trimmed) return '';
  const datePart = trimmed.includes('T') ? trimmed.split('T')[0] : trimmed.split(' ')[0];
  if (/^\d{4}-\d{2}-\d{2}$/.test(datePart)) {
    const [year, month, day] = datePart.split('-');
    return `${day}-${month}-${year}`;
  }
  return trimmed;
};

export const normalizeDobToIso = (value: string) => {
  if (!value) return '';
  const match = value.match(/^(\d{2})([-/])(\d{2})\2(\d{4})$/);
  if (match) {
    const day = match[1];
    const month = match[3];
    const year = match[4];
    return `${year}-${month}-${day}`;
  }
  return value;
};

export const isValidDob = (value: string) => {
  const match = value.match(/^(\d{2})([-/])(\d{2})\2(\d{4})$/);
  if (!match) return false;
  const dayStr = match[1];
  const monthStr = match[3];
  const yearStr = match[4];
  const day = Number(dayStr);
  const month = Number(monthStr);
  const year = Number(yearStr);
  if (!Number.isFinite(day) || !Number.isFinite(month) || !Number.isFinite(year)) return false;
  const currentYear = new Date().getFullYear();
  if (year < 1900 || year > currentYear) return false;
  const date = new Date(year, month - 1, day);
  if (Number.isNaN(date.getTime())) return false;
  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
};

export const isValidEmail = (value: string) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
};

export const formatCardNumber = (value: string, maxLength = 19) => {
  const rawDigits = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
  const digits = rawDigits.slice(0, Math.max(0, maxLength));
  const parts = digits.match(/.{1,4}/g);
  return parts ? parts.join(' ') : digits;
};

export const formatExpiry = (value: string) => {
  let digits = value.replace(/\D/g, '').slice(0, 4);
  if (digits.length === 1 && Number(digits) > 1) {
    digits = `0${digits}`;
  }
  if (digits.length >= 2) {
    let month = digits.slice(0, 2);
    const monthNum = Math.min(Math.max(Number(month), 1), 12);
    month = String(monthNum).padStart(2, '0');
    const year = digits.slice(2);
    return year ? `${month}/${year}` : month;
  }
  return digits;
};

export const toMoneyNumber = (value: unknown): number => {
  const numericValue =
    typeof value === 'number'
      ? value
      : typeof value === 'string'
        ? Number.parseFloat(value)
        : Number.NaN;
  return Number.isFinite(numericValue) ? numericValue : 0;
};
